import { render } from "./Itinerario.vue?vue&type=template&id=187383ea"
import script from "./Itinerario.vue?vue&type=script&lang=js"
export * from "./Itinerario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__